import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiSoType, ApiSoTypeFilter, FindOmpObjectResult } from "./types";

interface FindOmpObjectResponse {
    soCode: number;
    soType: number;
}

interface SoTypesListResponse {
    listData: ApiSoType[];
}

/**
 * Транспортный слой OMP — системные объекты (СО).
 */
export const soApi = {
    /**
     * Поиск СО по номеру.
     *
     * @param params.soNum — номер объекта, например `N0000FJ2TP`
     */
    findObject: async (params: { soNum: string }, config?: RequestConfig): Promise<FindOmpObjectResult> => {
        const data = await ompApiClient.postOmega<FindOmpObjectResponse>("so.findOmpObject", params, config);
        return {
            soCode: data.soCode,
            soType: data.soType,
        };
    },

    /**
     * Возвращает по фильтру данные типов объектов системы.
     * Запрос уходит в endpoint `so.loadSOTypeListByFilter`.
     */
    loadSOTypeListByFilter: async (params: { flt?: ApiSoTypeFilter } = {}, config?: RequestConfig): Promise<ApiSoType[]> => {
        const data = await ompApiClient.postOmega<SoTypesListResponse>(
            "so.loadSOTypeListByFilter",
            { flt: params.flt ?? {} },
            config,
        );
        return data.listData ?? [];
    },
} as const;
